import { render, staticRenderFns } from "./Wizard.vue?vue&type=template&id=16b44286&scoped=true"
import script from "./Wizard.vue?vue&type=script&setup=true&lang=js"
export * from "./Wizard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Wizard.vue?vue&type=style&index=0&id=16b44286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b44286",
  null
  
)

export default component.exports